<template>
    <div class="no-permission">
        <div class="no-permission__content">
            <img class="no-permission__image" src="@/assets/images/accessDenied.png" />

            <h2 class="no-permission__title" v-html="$t('PageNoPermission.title')"></h2>
            <p class="no-permission__paragraph" v-html="$t('PageNoPermission.paragraph')"></p>
            <div class="no-permission__buttons">
                <TotemButton
                class="no-permission__button"
                color="secondary"
                icon="arrow-left"
                @click="$router.go(-2)"
                v-if="showBackButton"
                :label="$t('General.go_back')"
            />
            <TotemButton
                class="no-permission__button"
                color="primary"
                @click="$router.push({name:'home-courses'})"
                :label="$t('PageCurrentlyUnavailable_go_to_frontpage')"
            />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'no-permission-page',
        computed: {
            showBackButton () {
                return this.previousRoutesCount > 1
            }
        },
        data () {
            return {
                previousRoutesCount: 0
            }
        },
        created () {
            this.previousRoutesCount = window.sessionStorage.getItem('previousRoutesCount')
        }
    }
</script>

<style lang="scss" scoped>
    .no-permission {
        background: $white;

        &__content {
            padding: 170px 0 170px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            text-align: center;
            width: 700px;
            align-items: center;

            [class*="mobile"] & {
                width: 100%;
                padding: 50px 0 150px;
            }
        }

        &__image {
            width: 40%;
            height: auto;
            z-index: 10;
        }

        &__buttons {
            display: flex;
            justify-content: center;
        }

        &__button {
            margin: 0 5px;
        }

        &__title {
            margin: 30px;
            font-size: 3.4rem;
            [class*="mobile"] & {
                font-size: 2.8rem;
            }
        }

        &__paragraph {
            font-size: 2.3rem;
            margin: 0 40px 40px;

            [class*="mobile"] & {
                font-size: 2.1rem;
            }
        }

        &__vector {
            z-index: 9;
            padding-top: -30px;
        }
    }
</style>
